import { Component, Injector } from "@angular/core";
import { AppComponentBase } from "@shared/common/app-component-base";
@Component({
    templateUrl:"./footer.component.html",
    selector:"qrmena-footer"
})
export class QrFooterComponent extends AppComponentBase{
    date:Date=new Date()

    constructor(injector: Injector) {
        super(injector);
    }
}


// WEBPACK FOOTER //
// ./src/QrMena/components/footer/footer.component.ts